module.exports = __webpack_public_path__ + "896add44a8256560b56ec5fd8ae9f837.MP3";